// extracted by mini-css-extract-plugin
export default {"MenuKebab":"MenuKebab_MenuKebab__xqcmx","MenuKebab__dropdown":"MenuKebab_MenuKebab__dropdown__DVSwl"};